var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"mousedown":_vm.com_SetLastActivityTime}},[(_vm.loginStatus)?_c('AppHeader'):_vm._e(),(_vm.loginStatus)?_c('LeftSideBar'):_vm._e(),_c('router-view'),(_vm.loginStatus)?_c('AppFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }